import React from 'react';
import PropTypes from 'prop-types';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

const timeTilReset = 5000;

export default class ActionInProgress extends React.Component {
    static propTypes = {
        onResetAction: PropTypes.func.isRequired,
    };

    constructor() {
        super();
        this.resetAction = this.resetAction.bind(this);

        this.state = {
            contactTimeout: setTimeout(this.resetAction, timeTilReset),
        };
    }

    componentWillUnmount() {
        this.clearTimer();
    }

    clearTimer() {
        clearTimeout(this.state.contactTimeout);
    }

    resetAction() {
        const { onResetAction } = this.props;

        this.clearTimer();
        onResetAction();
    }

    render() {
        return (
            <div className="inline-children-lg">
                <Text inline={true} type="h4">
                    {this.props.children}
                </Text>
                <Text lowlight={true} inline={true}>
                    <span
                        className="Inquiry-contact-cancel"
                        role="button"
                        tabIndex="0"
                        onKeyPress={this.resetAction}
                        onClick={this.resetAction}
                    >
                        Cancel
                    </span>
                </Text>
            </div>
        );
    }
}
